import lang from '../language';

export const options = [
  {
    name: lang.totalBySymbol(),
    value: 'totalBySymbol',
    description: lang.totalBySymbolDescription(),
    url: '/v2/reports-accounts/get-totals-by-symbol',
  },
  {
    name: lang.totalByDate(),
    value: 'totalByDate',
    description: lang.totalByDateDescription(),
    url: '/v2/reports-accounts/get-totals-by-date',
  },
  {
    name: lang.summaryByDate(),
    value: 'summaryByDate',
    description: lang.summaryByDateDescription(),
    url: '/v2/reports-accounts/get-summary-by-date',
  },
  {
    name: lang.detailedReport(),
    value: 'detailedReport',
    description: lang.detailedReportDescription(),
    url: '/v2/reports-accounts/get-detailed',
  },
  {
    name: lang.feesByDestination(),
    value: 'feesByDestination',
    description: lang.feesByDestinationDescription(),
    url: '/v2/reports-accounts/get-fees-by-destination',
  },
  {
    name: lang.adjustments(),
    value: 'adjustments',
    description: lang.adjustmentsDescription(),
    url: '/v2/reports-accounts/get-adjustments',
  },
];
